var map = {
	"./components/faq-section/FaqSection.global.vue": "674b",
	"./components/footer/Footer.global.vue": "fa73",
	"./components/info/Info.global.vue": "b892",
	"./components/modals/ConsumptionInfoModal.global.vue": "5f76",
	"./components/widgets-container/WidgetsContainer.global.vue": "0230",
	"./components/widgets/ConsumptionChart.global.vue": "9ed6",
	"./components/widgets/CurrentMonthConsumptionWidget.global.vue": "2747",
	"./components/widgets/LastMonthConsumptionWidget.global.vue": "e682",
	"./components/widgets/LastYearConsumptionWidget.global.vue": "bd16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "3433";
module.exports = webpackContext;